class TagBasedFilters extends HTMLElement {
  constructor() {
    super();
    this.triggers = this.querySelectorAll('input[data-tag-filter]');
    this.form = this.closest('form');
    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('change', this.onFilterChangeHandler.bind(this));
    });

    // Handle sorting
    const sortSelect = document.querySelectorAll('input[name="tag_sort_by"]');
    if (sortSelect.length > 0) {
      sortSelect.forEach(select => {
        select.addEventListener('change', this.onSortChangeHandler.bind(this));
      });
    }

    this.updateActiveFilter();
    
    // Initialize the filter loader
    this.initFilterLoader();
  }
  
  initFilterLoader() {
    // Get the collection section container
    const sectionContainer = document.querySelector('[data-section-id][data-section-type="collection-template"]');
    if (!sectionContainer) return;
    
    // Check if jQuery is available
    if (typeof jQuery === 'undefined') {
      console.warn('jQuery is required for tag filters but not available');
      return;
    }
    
    // Get base URL for the collection (without any filters)
    const collectionName = window.location.pathname.split('collections/')[1]?.split('/')[0];
    const baseUrl = window.location.pathname.split('collections/')[0] + 'collections/' + collectionName;
    
    // Create section object for the theme.LoadFilterer
    const section = {
      $container: jQuery(sectionContainer),
      namespace: '.collection',
      registerEventListener: function() {} // Dummy function
    };
    
    // Initialize the filterer if available
    // Pass baseUrl and set alterLocation to false so we can handle URL updates ourselves
    if (typeof theme !== 'undefined' && typeof theme.LoadFilterer !== 'undefined') {
      this.filterer = new theme.LoadFilterer(section, baseUrl, false);
    } else {
      console.warn('theme.LoadFilterer is not available');
    }
  }

  onFilterChangeHandler(e) {
    const target = e.target;
    const term = target.dataset.tagFilter; // This is the tag handle with prefix if any

    // Build the URL
    let url;
    const collectionName = window.location.pathname.split('collections/')[1]?.split('/')[0];
    const collectionUrl = window.location.pathname.split('collections/')[0] + 'collections/' + collectionName;
    
    if (!term) {
      url = collectionUrl;
      this.updateURL(collectionUrl);
    } else {
      url = `${collectionUrl}/${term}`;
      this.updateURL(`${collectionUrl}/${term}`);
    }

    // Use existing theme's AJAX functionality to update the products
    if (this.filterer && this.filterer.functions && this.filterer.functions.ajaxLoadUrl) {
      this.filterer.functions.ajaxLoadUrl.call(this.filterer, url);
    } else {
      // Fall back to regular page navigation if filterer not available
      window.location.href = url;
    }
    
    // Close mobile filter drawer if open
    if (this.closest('details')) {
      const close = this.closest('details').querySelector('.mobile-facets__close');
      if (close) close.click();
    }
  }

  onSortChangeHandler(e) {
    const sortValue = e.target.value;
    
    // Build the URL with sort parameter
    const currentUrl = window.location.pathname;
    const queryString = `?sort_by=${sortValue}`;
    const url = currentUrl + queryString;
    
    // Update the URL and load products
    if (this.filterer && this.filterer.functions && this.filterer.functions.ajaxLoadUrl) {
      this.filterer.functions.ajaxLoadUrl.call(this.filterer, url);
      this.updateURL(url);
    } else {
      // Fall back to regular page navigation
      window.location.href = url;
    }
  }

  updateURL(url) {
    // Manually update the URL in browser history
    history.pushState({ path: url }, '', url);
  }

  updateActiveFilter() {
    const location = window.location.href;
    const collectionName = location.split('collections/')[1]?.split('/')[0];
    if (!collectionName) return;
    
    const currentFilterValue = location.split(`${collectionName}/`)[1]?.split('?')[0] || '';
    
    // Set the correct radio button as checked
    this.triggers.forEach(trigger => {
      const filterValue = trigger.dataset.tagFilter;
      if (filterValue === currentFilterValue) {
        trigger.checked = true;
        
        // Ensure parent filter group is opened
        const filterGroup = trigger.closest('.filter-group__items');
        if (filterGroup && filterGroup.classList.contains('toggle-target--hidden')) {
          const toggle = document.querySelector(`[data-toggle-target=".${filterGroup.classList[1]}"]`);
          if (toggle) toggle.click();
        }
      } else if (!currentFilterValue && !filterValue) {
        // If no filter is active, check the View All option
        trigger.checked = true;
      }
    });
    
    // Handle sort selection
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    
    if (sortBy) {
      const sortRadios = document.querySelectorAll('input[name="tag_sort_by"]');
      sortRadios.forEach(radio => {
        if (radio.value === sortBy) {
          radio.checked = true;
        }
      });
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  customElements.define('tag-based-filters', TagBasedFilters);
  
  // Handle browser back/forward navigation
  window.addEventListener('popstate', (event) => {
    // Let theme.LoadFilterer handle loading content
    const tagFiltersForm = document.querySelector('tag-based-filters');
    if (tagFiltersForm) {
      tagFiltersForm.updateActiveFilter();
      
      // Reload filtered products if needed based on current URL
      if (tagFiltersForm.filterer) {
        const currentPath = window.location.pathname + window.location.search;
        tagFiltersForm.filterer.functions.ajaxLoadUrl.call(tagFiltersForm.filterer, currentPath);
      }
    }
  });
}); 